import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  };
}

export default function CouldNotBookModal({ row, onCancel, onConfirmed }) {
  const [busy, setBusy] = useState(false);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  async function confirm() {
    setBusy(true);
    setError("");
    try {
      await axios.post(
        `${API_URL}/book-it/admin/${row.booking_request_id}/could-not-book`,
        { reason: reason || null },
        { headers: authHeaders() }
      );
      onConfirmed();
    } catch (err) {
      setError(err?.response?.data?.detail || "Update failed. Please try again.");
      setBusy(false);
    }
  }

  return (
    <div
      onClick={busy ? undefined : onCancel}
      className="fixed inset-0 z-[1000] flex items-center justify-center px-5 bg-slate-900/60 backdrop-blur-[2px]"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl p-7 w-full max-w-md shadow-2xl text-slate-900"
      >
        <h2 className="text-xl font-bold tracking-tight text-slate-900 mb-3">
          Mark as could not book?
        </h2>
        <p className="text-sm text-slate-600 leading-relaxed mb-4">
          The carrier <strong className="font-semibold text-slate-900">will not be charged</strong>.
          Their saved payment method stays on file for next time.
        </p>
        <label className="block text-sm font-medium text-slate-600 mb-4">
          Reason (optional)
          <textarea
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="e.g. broker rejected, load no longer available"
            className="block w-full mt-1.5 px-3 py-2.5 border border-slate-300 rounded-lg text-sm bg-white text-slate-900 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 resize-y"
          />
        </label>
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg px-3.5 py-2.5 text-sm mb-3">
            {error}
          </div>
        )}
        <div className="flex justify-end gap-2.5">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="!shadow-none !bg-white !text-slate-700 !border !border-slate-300 hover:!bg-slate-50 !rounded-lg !px-4 !py-2.5 !text-sm !font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirm}
            disabled={busy}
            className="!shadow-none !bg-indigo-600 hover:!bg-indigo-700 !text-white !border-0 !rounded-lg !px-4 !py-2.5 !text-sm !font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {busy ? "Saving…" : "Yes, mark as could not book"}
          </button>
        </div>
      </div>
    </div>
  );
}
